export const arrOptionNumber = [
  {
    label: "1",
    value: "1",
  },
  {
    label: "2",
    value: "2",
  },
  {
    label: "3",
    value: "3",
  },
  {
    label: "4",
    value: "4",
  },
  {
    label: "5",
    value: "5",
  },
  {
    label: "6",
    value: "6",
  },
  {
    label: "7",
    value: "7",
  },
  {
    label: "8",
    value: "8",
  },
  {
    label: "9",
    value: "9",
  },
];

export const ecommercePlatformOptions = [
  { label: "Amazon", value: "amazon" },
  { label: "Flipkart", value: "flipkart" },
  { label: "Myntra", value: "myntra" },
  { label: "Ajio", value: "ajio" },
  { label: "Meesho", value: "meesho" },
  { label: "Nykaa", value: "nykaa" },
  { label: "Tata CLiQ", value: "tata_cliq" },
  { label: "Snapdeal", value: "snapdeal" },
  { label: "FirstCry", value: "firstcry" },
  { label: "Reliance Digital", value: "reliance_digital" },
  { label: "Others", value: "others" },
];

export const StatusOptionDropdown = [
  {
    label: "Active",
    value: true,
  },
  {
    label: "Disable",
    value: false,
  },
];

export const CouponStatusOptionDropdown = [
  {
    label: "Active",
    value: "active",
  },
  {
    label: "Disable",
    value: "expired",
  },
];

export const arrOptionSize = [
  { label: "SMALL", value: "small" },
  { label: "LARGE", value: "large" },
  { label: "MEDIUM", value: "medium" },
];
export const videoOption = [
  { label: "YES", value: "yes" },
  { label: "NO", value: "no" },
];
export const selfDropTimeOptions = [
  { label: "09:00 AM - 12:00 PM", value: "09:00-12:00" },
  { label: "12:00 PM - 03:00 PM", value: "12:00-15:00" },
  { label: "03:00 PM - 06:00 PM", value: "15:00-18:00" },
  { label: "06:00 PM - 09:00 PM", value: "18:00-21:00" },
];
export const paymentStatusOptions = [
  { label: "Paid", value: "paid" },
  { label: "Partial Paid", value: "partial_paid" },
  { label: "Unpaid", value: "not_paid" },
];

export const timeOptions = [
  { label: "12:00 AM", value: "00:00" },
  { label: "1:00 AM", value: "01:00" },
  { label: "2:00 AM", value: "02:00" },
  { label: "3:00 AM", value: "03:00" },
  { label: "4:00 AM", value: "04:00" },
  { label: "5:00 AM", value: "05:00" },
  { label: "6:00 AM", value: "06:00" },
  { label: "7:00 AM", value: "07:00" },
  { label: "8:00 AM", value: "08:00" },
  { label: "9:00 AM", value: "09:00" },
  { label: "10:00 AM", value: "10:00" },
  { label: "11:00 AM", value: "11:00" },
  { label: "12:00 PM", value: "12:00" },
  { label: "1:00 PM", value: "13:00" },
  { label: "2:00 PM", value: "14:00" },
  { label: "3:00 PM", value: "15:00" },
  { label: "4:00 PM", value: "16:00" },
  { label: "5:00 PM", value: "17:00" },
  { label: "6:00 PM", value: "18:00" },
  { label: "7:00 PM", value: "19:00" },
  { label: "8:00 PM", value: "20:00" },
  { label: "9:00 PM", value: "21:00" },
  { label: "10:00 PM", value: "22:00" },
  { label: "11:00 PM", value: "23:00" },
];
